import type { Role, Session } from "../types";

const TOKEN_KEY = "token";
const ID_KEY = "assigned-id";
const ROLE_KEY = "role";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getAssignedID(): string {
  return localStorage.getItem(ID_KEY) || "";
}

export function getRole(): Role | null {
  return (localStorage.getItem(ROLE_KEY) as Role | null) ?? null;
}

export function getSession(): Session | null {
  const token = getToken();
  const role = getRole();
  if (!token || !role) return null;
  return { token, role, assignedID: getAssignedID() };
}

export function saveSession(session: Session): void {
  localStorage.setItem(TOKEN_KEY, session.token);
  localStorage.setItem(ID_KEY, session.assignedID);
  localStorage.setItem(ROLE_KEY, session.role);
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ID_KEY);
  localStorage.removeItem(ROLE_KEY);
}
